import { createTranslations } from '@npco/common-utils-translations'

export const noActiveAccountsPopperTranslations = createTranslations({
  title: 'You have no active Accounts',
  description:
    'Create a Zeller Transaction Account to transfer funds and receive direct payments instantly.',
  actionButton: 'Add Account',
})
